import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from '@heroicons/react/24/solid';
import { Typography, Row, Col, Card, Button, Tag, Skeleton } from 'antd';
import { useServicesContent, getContentByKey } from '../../hooks/useDynamicContent';

function Services() {
    const { content: servicesContent, loading: contentLoading } = useServicesContent();
    
    const services = useMemo(() => {
        try {
            const raw = getContentByKey(servicesContent, 'services_list', '[]');
            const parsed = JSON.parse(raw);
            return Array.isArray(parsed) && parsed.length ? parsed : [];
        } catch (e) {
            return [];
        }
    }, [servicesContent]);

    return (
        <div className="bg-white py-24 sm:py-32">
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-2xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                        {contentLoading ? (
                            <Skeleton.Input active size="large" style={{ width: '80%', margin: '0 auto' }} />
                        ) : (
                            getContentByKey(servicesContent, 'services_title', 'Our Catering Services')
                        )}
                    </h2>
                    <p className="mt-6 text-lg leading-8 text-gray-600">
                        {contentLoading ? (
                            <Skeleton.Input active size="default" style={{ width: '100%', margin: '0 auto' }} />
                        ) : (
                            getContentByKey(servicesContent, 'services_subtitle', 'We offer a wide range of catering services to meet all your event needs.')
                        )}
                    </p>
                </div>
                <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-8 lg:mx-0 lg:max-w-none lg:grid-cols-2">
                    {services.map((service) => (
                        <div
                            key={service.name}
                            className="flex flex-col justify-between rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200"
                        >
                            <div>
                                <h3 className="text-xl font-semibold text-gray-900">{service.name}</h3>
                                <p className="mt-4 text-gray-600">{service.description}</p>
                                <ul className="mt-6 space-y-3">
                                    {(service.features || []).map((feature) => (
                                        <li key={feature} className="flex items-center">
                                            <CheckIcon className="h-5 w-5 text-orange-600" />
                                            <span className="ml-3 text-sm text-gray-600">{feature}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="mt-8">
                                {service.href && (
                                    <Link
                                        to={service.href}
                                        className="text-sm font-semibold text-orange-600 hover:text-orange-500"
                                    >
                                        Learn more <span aria-hidden="true">→</span>
                                    </Link>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default Services;
